// extracted by mini-css-extract-plugin
module.exports = {"container":"wording-module__container___1I-1l","elements":"wording-module__elements___2WpvB","label":"wording-module__label___g3GSm"};